<template>
  <div class="chart" ref="chartdiv"></div>
</template>

<script>
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import am4themes_material from "@amcharts/amcharts4/themes/material";

// Themes to chart
am4core.useTheme(am4themes_material);
am4core.useTheme(am4themes_animated);

export default {
  name: 'ProgressChart',
  props: ['data'],
  data() {
    return {
      chart: null,
    }
  },
  methods: {
    createSeries (chart, field, name, color, dashed) {
      var series = chart.series.push(new am4charts.LineSeries())
      series.dataFields.valueY = field
      series.dataFields.categoryX = 'year'
      series.name = name
      series.tooltipText = '[bold]{name}[/]\n Vid {categoryX} års ålder: [b]{valueY}[/]'
      series.tooltip.getFillFromObject = false
      series.tooltip.background.fill = am4core.color('#0F7354')
      series.strokeWidth = 2
      series.smoothing = 'monotoneX'
      series.stroke = color

      if (dashed) {
        series.strokeDasharray = '5 3'
      }
    }
  },
  watch: {
    data(newVal) {
      if (this.chart) {
        this.chart.data = newVal;
        this.chart.validateData();
      }
    }
  },
  mounted () {
    let chart = am4core.create(this.$refs.chartdiv, am4charts.XYChart)

    chart.dateFormatter.dateFormat = 'YYYY'
    chart.numberFormatter.numberFormat = '#.#a'

    // Add data
    chart.data = this.data

    // Make space for title
    chart.paddingTop = 30

    // x Axis
    var categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis())
    categoryAxis.dataFields.category = 'year';
    categoryAxis.title.text = 'Ålder';
    categoryAxis.title.fontWeight = 600

    // y Axis
    var valueAxis = chart.yAxes.push(new am4charts.ValueAxis())
    valueAxis.layout = 'absolute'
    valueAxis.renderer.minLabelPosition = 0.05
    valueAxis.renderer.maxLabelPosition = 0.95
    // y Title
    valueAxis.title.text = 'Kronor'
    valueAxis.title.rotation = 0
    valueAxis.title.valign = 'top'
    valueAxis.title.align = 'center'
    valueAxis.title.dy = -30
    valueAxis.title.fontWeight = 600
    // Flip axis tooltip
    valueAxis.updateTooltip = ()=>{};
    valueAxis.tooltip.pointerOrientation = "left";

    this.createSeries(chart, 'without', 'Utan POND', am4core.color('#B1B106'))
    this.createSeries(chart, 'high', 'Hög 10%', am4core.color('#D68C45'), true)
    this.createSeries(chart, 'medium', 'Medel 5%', am4core.color('#2C6E49'), true)
    this.createSeries(chart, 'low', 'Låg 1%', am4core.color('#B1B106'), true)

    chart.cursor = new am4charts.XYCursor()
    this.chart = chart;
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.dispose();
      this.chart = null;
    }
  }
}
</script>

<style lang="scss" scoped>
.chart {
  width: 100%;
  height: 400px;
  font-family: "Roboto", sans-serif;
}
</style>